import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import {
  ClassEntity,
  CourseEntity,
  SeasonEntity,
  UniversityTermEntity,
  VseApplicationEntity
} from 'vse-material-ui';
import {
  MyApplState
} from './myApplTypes';
import {
  useTypedSelector
} from '../../store';
import * as VseSession from '../session';
import * as VseAlert from '../alert';

const initialState = {
  loading: 'idle',
  seasonsOpening: [],
  myAppl: [],
  seasons: [],
  classes: [],
  courses: [],
  universityTerms: [],
} as MyApplState;

export const load = createAsyncThunk('myAppl/load', async (_, thunkApi) => {
  try {
    const response = await axios.get<{
      seasonsOpening: SeasonEntity[],
      myAppl: VseApplicationEntity[],
      seasons: SeasonEntity[],
      classes: ClassEntity[],
      courses: CourseEntity[],
      universityTerms: UniversityTermEntity[],
    }>(`api/myAppl`);
    return response;
  } catch (err) {
    const error: AxiosError = err;
    if (!VseAlert.tryHandleTimeout(thunkApi, error)) {
      VseAlert.handleThunkError(thunkApi, error);
    }
    return thunkApi.rejectWithValue(error);
  }
});

export const myApplSlice = createSlice({
  name: 'myAppl',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = initialState.loading;
      state.seasonsOpening = initialState.seasonsOpening;
      state.myAppl = initialState.myAppl;
      state.seasons = initialState.seasons;
      state.classes = initialState.classes;
      state.courses = initialState.courses;
      state.universityTerms = initialState.universityTerms;
    },
  },
  extraReducers: builder => {
    builder.addCase(VseSession.reset, (state) => {
      state = Object.assign(state, initialState);
    });
    builder.addCase(load.pending, (state) => {
      state.loading = 'pending';
    });
    builder.addCase(load.fulfilled, (state, action) => {
      state.loading = 'succeeded';
      state.seasonsOpening = action.payload.data.seasonsOpening;
      state.myAppl = action.payload.data.myAppl;
      state.seasons = action.payload.data.seasons;
      state.classes = action.payload.data.classes;
      state.courses = action.payload.data.courses;
      state.universityTerms = action.payload.data.universityTerms;
    });
    builder.addCase(load.rejected, (state) => {
      state.loading = 'failed';
      state.seasonsOpening = [];
      state.myAppl = [];
      state.seasons = [];
      state.classes = [];
      state.courses = [];
      state.universityTerms = [];
    });
  },
});

export const { reset } = myApplSlice.actions;

export default myApplSlice.reducer;

export const useMyApplState = (): MyApplState => useTypedSelector(state => state.myAppl);
